import toast from 'react-hot-toast';

const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const RazorpayCheckout = {
  /**
   * @param {Object} params
   * @param {string} params.orderId
   * @param {number} params.amount
   * @param {string} params.currency
   * @param {string} params.planName
   * @param {Function} params.onSuccess
   * @param {Function} params.onFailure
   * @param {Function} [params.onOpen]  Call this to hide your parent modal (e.g. setShowModal(false))
   * @param {Function} [params.onClose] Call this to show your parent modal again (e.g. setShowModal(true))
   */
  async initiatePayment({ orderId, amount, currency, planName, onSuccess, onFailure, onOpen, onClose }) {
    try {
      const isLoaded = await loadRazorpayScript();

      if (!isLoaded) {
        toast.error('Failed to load Razorpay SDK. Please try again.');
        return;
      }

      const options = {
        key: import.meta.env.VITE_RAZORPAY_KEY_ID,
        amount,
        currency,
        name: 'CareerPath',
        description: `${planName} Plan Subscription`,
        order_id: orderId,
        handler: function (response) {
          onClose?.();
          onSuccess({
            razorpayOrderId: response.razorpay_order_id,
            razorpayPaymentId: response.razorpay_payment_id,
            razorpaySignature: response.razorpay_signature
          });
        },
        prefill: {
          name: '',
          email: '',
          contact: ''
        },
        theme: {
          color: '#1a2642'
        },
        modal: {
          ondismiss: function () {
            onClose?.();
            onFailure('Payment cancelled by user');
          }
        },
        config: {
          display: {
            blocks: {
              upi: {
                name: 'Pay using UPI',
                instruments: [
                  {
                    method: 'upi',
                    flows: ['collect', 'intent', 'qr']
                  }
                ]
              },
              qr: {
                name: 'Scan & Pay',
                instruments: [{ method: 'qr' }]
              },
              card: {
                name: 'Pay using Card',
                instruments: [{ method: 'card' }]
              },
              netbanking: {
                name: 'Netbanking',
                instruments: [{ method: 'netbanking' }]
              }
            },
            sequence: ['upi', 'qr', 'card', 'netbanking'],
            preferences: {
              show_default_blocks: false
            }
          }
        }
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on('payment.failed', function (response) {
        onClose?.();
        onFailure(response.error.description || 'Payment failed');
      });

      // Let the caller hide its own modal instead of us injecting global CSS
      onOpen?.();
      razorpay.open();
    } catch (error) {
      console.error('Razorpay checkout error:', error);
      onFailure(error.message || 'Payment initialization failed');
    }
  }
};

export default RazorpayCheckout;